import { ProductType } from "./machine";

const ERROR_SOURCE_PATTERN = {
    MMC: /^([0-9]+)([.][0-9]+)*$/,
    TruControl: /^[a-f|A-F|0-9]{4}( |.)?[a-f|A-F|0-9]{4}$/,
    AM_HMI: /^[0-9]*$/,
    AM_DESKTOP: /^[0-9]*$/,
    AM_TITP: /^[A-Z]{3-4}(-)[0-9]{5}$/
};

const UNKNOWN = "UNDEFINED";

export const getErrorSource = (errorNumber: string, productNo: string, machines: ProductType[]): string => {
    const machine = machines.find((machine) => machine.productNo === productNo);
    if (!machine) {
        return UNKNOWN;
    }

    const filteredErrorSources = machine.errorSources.filter((errorSource) => {
        if (ERROR_SOURCE_PATTERN[errorSource].test(errorNumber)) {
            return errorSource;
        }
        return false;
    });
    if (filteredErrorSources.length === 0) {
        return UNKNOWN;
    }
    return filteredErrorSources[0];
};
